import {pullRequestsAppBuilder} from '../config/app-builder'
import type {CommitsRouteWithHeaderDataPayload} from './route-payload-types'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import type {NavigationCounterPageData} from '../page-data/payloads/tab-counts'
import {mainQuery} from '@github-ui/react-core/future/query-configs'
import {queryFnFetch} from '@github-ui/react-core/future/query-fn-fetch'

// This route is currently duplicated with the route in `commits-route.ts`. Both routes exist so that we can
// safely roll out the new layout route behind the react_data_router_pull_requests_layout FF. Once that FF is fully rolled out and ready to be removed,
// we can remove this route as well. See https://github.com/github/react-platform/issues/409
export const pullRequestsCommitsRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsCommitsRoute', {
  path: '/:owner/:repo/pull/:pr_number/commits',
  queries: [
    mainQuery<CommitsRouteWithHeaderDataPayload>({queryDeps: ({pathname}) => ({pathname})}),
    {
      queryName: 'tabCounts',
      queryDeps: ({params}) => {
        return {pathname: `/${params.owner}/${params.repo}/pull/${params.pr_number}/page_data/tab_counts`}
      },
      queryFn: async queryKey => queryFnFetch<NavigationCounterPageData>(queryKey),
      type: QueryRouteQueryType.Deferred,
    },
  ],
})
